//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showPositionValue: false,
      isActive: true,
      loading: false,
      isShow: true, // 已作废，之前捐赠的标志
      isDisabled: false,
      show: false,
      showApply: false,
      errorMsg: "",
      count: 0, // 倒计时
      inShowList: [
        {
          // title: '参展说明',
          desc:
            "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
          meta: {
            source: "展位5万元/个",
            date: "",
            other: "卫星会10万元/场/30min"
          }
        }
      ],
      donateList: [
        {
          // title: '捐赠说明',
          desc:
            "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
        }
      ],
      addForm: {
        // 参展选择
        activeId: "",
        supportOption: "参展",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        // 报名表填写字段
        id: "",
        activeId: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "专票",
        invoiceTitle: "",
        taxNo: "",
        tel: "",
        address: "",
        telAddress: "",
        bank: "",
        bcount: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0,
        checkCode: ""
      },
      rules: {
        supportOption: "请选择参与性质",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
        checkCode: "请输入验证码"
      }
    };
  },
  async mounted() {
    this.addForm.activeId = this.$route.params.activeId;
    if (!this.addForm.activeId) {
      this.addForm.activeId = this.$route.params.id;
    }
  },
  computed: {
    smsMessage() {
      return this.count ? `${this.count} 秒` : "获取验证码";
    }
  },
  methods: {
    /**
     * 返回首页
     *
     */
    goback() {
      this.$router.push({ name: "login", params: { activeId: this.addForm.activeId } });
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
    /**
     * 参展
     *
     */
    inShow() {
      this.isActive = true;
      this.addForm.supportOption = "参展";
    },
    /**
     * 下一步
     */
    inShowNext() {
      if (!this.addForm.showCount && !this.addForm.sateCount) {
        this.showMsg("展位数和卫星会不能同时为空");
        return;
      }
      this.showApply = true;
      console.log(this.addForm)
      // this.$router.push({ name: "register", params: this.addForm });
    },
    /**
     * 上一步
     */
    inShowPrev() {
      this.showApply = false;
      // this.$router.push({ name: "register", params: this.addForm });
    },
    /**
     * 捐赠
     *
     */
    donate() {
      this.isActive = false;
      this.addForm.supportOption = "捐赠";
    },
    /**
     * 下一步
     */
    donateNext() {
      this.$router.push({ name: "register", params: this.addForm });
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    async getMobilCode() {
      if (!this.addForm.cellPhone) {
        this.showMsg("请先输入手机号！");
        return;
      }
      if (!this.isCellPhone(this.addForm.cellPhone)) {
        this.showMsg("请输入有效的手机号！");
        return;
      }

      if (this.count) return;

      if (this.interval) {
        clearInterval(this.interval);
      }
      try {
        const getCheckCode = this.$apis.common.checkCode;
        await this.$axios.get(
          `${getCheckCode}/${this.addForm.cellPhone}/${this.addForm.activeId}/1`
        );
        this.showMsg("短信发送成功！");
        this.count = 59;
        this.interval = setInterval(() => {
          if (this.count <= 0) {
            clearInterval(this.interval);
            return;
          }
          return this.count--;
        }, 1000);
      } catch (err) {
        console.log(err.data.msg);
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.count = 0;
        this.showMsg(err.data.msg);
      }
    },
    /** 
     * 报名表单取消提交操作
     */
    onCancel() {
      console.log("on cancel");
    },
    /**
     * 报名表单确认提交
     */
    async onConfirm() {
      this.isDisabled = true;
      this.addForm.telAddress = this.addForm.tel + this.addForm.address;
      this.addForm.bankCount = this.addForm.bank + this.addForm.bcount;
      this.addForm.id = "";
      const add = this.$apis.exhibition.add;
      try {
        const { data } = (await this.$axios.post(add, this.addForm)) || {};
        this.showMsg("提交成功！");
        localStorage.setItem('X_TOKEN', data.token);
        this.$router.push({
          name: "success",
          params: { activeId: this.addForm.activeId }
        });
      } catch (err) {
        this.showMsg(err.data.msg);
        this.isDisabled = false;
      }
    },
    onHide() {
      console.log("on hide");
    },
    onShow() {
      console.log("on show");
    },
    /**
     * 提交报名数据
     *
     */
    async submitAdd() {
      for (let key in this.rules) {
        if (!this.addForm[key]) {
          this.showMsg(this.rules[key]);
          // this.isDisabled = false;
          return;
        }
      }
      this.show = true;
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/choose.vue